import React from 'react';

import PropTypes from 'prop-types';

import CreateReturnLabelActionOptions from './create-return-label-action-options';
import messages from './messages';
import RmaNumberInput from './rma-number-input';
import { Presets, ShipFrom, Weight, ShippingService, Package, Size, Confirmation, Insurance } from '../../../configure-shipment/fields';
import ConfigureShipmentSection from '../../../configure-shipment/section/configure-shipment-section';
import ConfigureShipmentForm from '../../../configure-shipment/form/configure-shipment-form';
import { ConfigureReturnShipmentFormFooter } from './configure-return-shipment-form-footer';

import style from './configure-return-shipment.module.less';

const ConfigureReturnShipment = ({ returnFulfillmentPlanId }) => {
  return (
    <ConfigureShipmentSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style['configure-return-shipment-section-body']}
      headerActions={<Presets fulfillmentPlanId={returnFulfillmentPlanId} />}
      sectionTitleMessageDescriptor={messages.sectionTitle}
    >
      <ConfigureShipmentForm>
        <ShipFrom fulfillmentPlanId={returnFulfillmentPlanId} isReturn />
        <Weight />
        <ShippingService fulfillmentPlanId={returnFulfillmentPlanId} />
        <Package fulfillmentPlanId={returnFulfillmentPlanId} />
        <Size fulfillmentPlanId={returnFulfillmentPlanId} />
        <Confirmation />
        <Insurance fulfillmentPlanId={returnFulfillmentPlanId} />
      </ConfigureShipmentForm>
      <ConfigureReturnShipmentFormFooter>
        <div className={style.divider} />
        <RmaNumberInput />
        <div className={style.divider} />
        <CreateReturnLabelActionOptions />
      </ConfigureReturnShipmentFormFooter>
    </ConfigureShipmentSection>
  );
};

export default ConfigureReturnShipment;

ConfigureReturnShipment.propTypes = {
  returnFulfillmentPlanId: PropTypes.string.isRequired,
};
